import { FC } from 'react';

import { DatePicker, DatePickerProps, Form } from 'antd';
import { Rule } from 'antd/es/form';
import { NamePath } from 'antd/es/form/interface';

import DEFAULT_DATE_FORMAT, {
	DEFAULT_DATE_FORMAT_PLACEHOLDER,
} from '@/constants/defaultDateFormat';

import calendarIcon from '@/assets/icons/calendar-icon.svg';

import './DatePickerFormItem.scss';

import dayjs from '@/configs/dayjsConfig';

interface IDatePickerFormItemProps {
	marginBottom?: number;
	name: NamePath;
	label?: string | React.ReactNode;
	required?: boolean;
	rules?: Rule[];
	datePickerProps?: DatePickerProps;
}

const DatePickerFormItem: FC<IDatePickerFormItemProps> = ({
	marginBottom = 16,
	name,
	label,
	required = true,
	rules,
	datePickerProps,
}) => {
	return (
		<Form.Item
			className={'date-wrapper'}
			getValueFromEvent={(event: dayjs.Dayjs) => {
				return event.set('hour', 12).utc();
			}}
			label={label}
			name={name}
			rules={
				rules ?? [
					{
						required,
					},
				]
			}
			style={{ marginBottom }}
		>
			<DatePicker
				className={'date-picker'}
				disabledDate={(currentDate) => {
					return currentDate && currentDate > dayjs().endOf('day');
				}}
				format={DEFAULT_DATE_FORMAT}
				placeholder={DEFAULT_DATE_FORMAT_PLACEHOLDER}
				style={{ display: 'flex' }}
				suffixIcon={<img alt={'input-icon'} src={calendarIcon} />}
				{...datePickerProps}
			/>
		</Form.Item>
	);
};

export default DatePickerFormItem;
